
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.326 12.289a.483.483 0 01-.356-.144.485.485 0 01-.143-.356V4.902l-2.76 2.76a.428.428 0 01-.327.14.519.519 0 01-.361-.155.513.513 0 01-.166-.361.5.5 0 01.166-.357l3.363-3.363a.774.774 0 01.27-.184.892.892 0 01.605 0c.099.036.19.097.275.184l3.389 3.388c.097.097.148.209.153.335a.483.483 0 01-.16.358.522.522 0 01-.353.158.485.485 0 01-.354-.163l-2.74-2.74v6.906c0 .136-.048.25-.144.342a.495.495 0 01-.357.139zm5.364 8.363a.893.893 0 01-.307-.054.74.74 0 01-.275-.182l-3.389-3.389a.487.487 0 01-.153-.335.483.483 0 01.159-.358.522.522 0 01.354-.158.485.485 0 01.354.163l2.74 2.74v-6.906c0-.136.048-.25.144-.342a.495.495 0 01.357-.139c.142 0 .26.048.356.144a.485.485 0 01.143.356v6.887l2.76-2.76a.428.428 0 01.326-.14c.131 0 .252.052.362.155.11.113.165.234.165.361a.5.5 0 01-.165.357l-3.363 3.364a.774.774 0 01-.27.183.83.83 0 01-.298.053z","fill":"#fff"}})])
          )
        }
      }
    